module.exports = __webpack_public_path__ + "content/1d0d2751ac04b4da6b844014910a5a28.png";